// import "firebase/firestore";

import { setLogLevel } from "firebase/firestore";
import { getAuth, sendPasswordResetEmail } from "firebase/auth";

// import { Storage } from "@google-cloud/storage";
import { getDatabase } from "firebase/database";
import { initializeApp } from "firebase/app";

// consooe.log("Storage", Storage);
// const storage = new Storage({
//   projectId: "	hopsavings-6d90f",
//   keyFilename: "/path/to/service-account.json", // securely stored on backend only
// });

const firebaseConfig = {
  apiKey: "AIzaSyBImxrYmDc4EpBQNsfz5094P3Gl-_WqcYs",
  authDomain: "hopsavings-6d90f.firebaseapp.com",
  databaseURL: "https://hopsavings-6d90f-default-rtdb.firebaseio.com",
  projectId: "hopsavings-6d90f",
  storageBucket: "hopsavings-6d90f.firebasestorage.app",
  messagingSenderId: "377678987604",
  appId: "1:377678987604:web:135ce87976eb48311548c1",
  measurementId: "G-H8N1X0WT0B",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const firebaseDB = getDatabase(app);

setLogLevel("debug");

export { auth, sendPasswordResetEmail, firebaseDB };
